import React, { useState } from "react";
import "./styles/Contact.css";
import { useForm } from "react-hook-form";
import PageOverView from "../components/Page Overview";
import { motion } from "framer-motion";
import FormField from "../components/FormField";
import { useNavigate } from "react-router-dom";
const Contact = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const response = await fetch(`api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      await response.json();
      //eslint-disable-next-line react-hooks/rules-of-hooks
      navigate('/ThankYou');

    } catch (error) {
      // toast('Error when submit');
    }
  };
  const formFields = [
    {
      id: "name",
      label: "Name",
      placeholder: "Please provide your name",
      type: "text",
      validation: { required: "Name is required!" },
    },
    {
      id: "companyName",
      label: "Company Name",
      placeholder: "Please provide your company name",
      type: "text",
      validation: { required: "Company Name is required!" },
    },
    {
      id: "email",
      label: "Email",
      placeholder: "Please provide your email",
      type: "email",
      validation: {
        required: "Email is required!",
        pattern: {
          value: /^[\w.\\-]+@[\w.\\-]+\.[A-Za-z]+$/,
          message: "Please provide email in correct format!",
        },
      },
    },
    {
      id: "tel",
      label: "Telephone",
      placeholder: "Please provide your phone",
      type: "text",
      validation: { required: "Telephone is required!" },
    }
  ];
  return (
    <>
      <div className="page-overview">
        <PageOverView text="Contact Us" />
      </div>
      <div className="contact_form">
        <form onSubmit={handleSubmit(onSubmit)}>
          {formFields.map((field, index) => (
            <FormField
              key={field.id}
              id={field.id}
              label={field.label}
              placeholder={field.placeholder}
              type={field.type}
              register={register}
              validation={field.validation}
              errors={errors}
              options={field.options}
              motionProps={{
                initial: { opacity: 0, x: index % 2 === 0 ? 100 : -100 },
                animate: { opacity: 1, x: 0 },
                exit: { opacity: 0, x: 100 },
                transition: { duration: 0.7 },
              }}
            />
          ))}

          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.7 }}
          >
            <FormField
              id="body"
              label="Inquiry Content"
              placeholder="Please provide details of your inquiry"
              type="textarea"
              register={register}
              validation={{
                maxLength: {
                  value: 200,
                  message: "Please input less than 200 characters!",
                },
              }}
              errors={errors}
              motionProps={{
                initial: { opacity: 0, x: -100 },
                animate: { opacity: 1, x: 0 },
                exit: { opacity: 0, x: 100 },
                transition: { duration: 0.7 },
              }}
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.7 }}
          >
            <div class="contact-privacypolicy">
              <p>
                <span>"Policy on Submitting Contact Forms"</span>
                <br />
                (1) Name or Title of the Business Entity
                <br />
                Beta Japan Software
              </p>
              <p>
                (2) Purpose of Use of Personal Information
                <br />
                The personal information provided in the contact form will be used solely for the purpose of responding to your inquiry.
              </p>
              <p>
                (3) Provision of Personal Information to Third Parties
                <br />
                We will not share your personal information with third parties without your consent, unless required by law or legal obligations.
              </p>
              <p>
                (4) Outsourcing of Personal Information Handling
                <br />
                In the event that personal information is entrusted to a third party for handling, we will ensure that the third party complies with necessary privacy and safety standards by entering into appropriate contracts.
              </p>
              <p>
                (5) Consequences of Not Providing Personal Information
                <br />
                Providing your personal information is voluntary. However, if certain details are not provided, we may be unable to respond to your inquiry.
              </p>
              <p>
                (6) Disclosure of Personal Information and Inquiry Contact
                <br />
                Upon your request, we will disclose the personal information we hold, including its purpose of use, and provide you with options to correct, add, delete, or stop its use. For inquiries, please contact the "Privacy Policy Inquiry" below.
              </p>
              <p>
                (7) Methods of Collecting Personal Information That Are Not Easily Recognized by the Individual
                <br />
                We do not collect personal information through methods that are not easily detectable, such as cookies or tracking technologies, without your knowledge.
              </p>
              <p>
                (8) About Cookies
                <br />
                We use cookies to improve the user experience and to personalize content or advertisements. You can adjust your browser settings to accept or reject cookies. Please note that rejecting cookies may affect some features of the website.
              </p>
              <p>
                (9) Measures for the Safe Management of Personal Information
                <br />
                We will take appropriate measures to prevent unauthorized access to or disclosure of personal information, and will delete your personal information after processing your inquiry.
              </p>
            </div>

          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.7 }}
          >
            <div className="acceptance">
              <label>
                <input
                  type="checkbox"
                  name="acceptance"
                  value="1"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="checkbox-acceptance"
                />
                <span className="wpcf7-list-item-label">
                  I agree to the above handling of personal information
                </span>
              </label>
            </div>
          </motion.div>

          <button className="submit_btn" id="submit_btn" disabled={!isChecked}>
            Send
          </button>
        </form>
      </div>
    </>
  );
};
export default Contact;
